module.exports = __webpack_public_path__ + "img/tag5.b9841314.png";